import { FC } from "react";
import { styled } from "@mui/material/styles";
import MuiAlert, { AlertProps } from "@mui/material/Alert";
import ReportIcon from "@mui/icons-material/Report";

const StyledAlert = styled(MuiAlert)(({ theme }) => ({
  alignItems: "center",
  display: "flex",
  flexDirection: "row",
  height: 80,
  padding: `0 ${theme.spacing(3)}`,
  "& .MuiAlert-message": {
    color: theme.colors.black,
    fontFamily: theme.fonts.bold,
    fontSize: 18,
  },

  "&.MuiAlert-colorError": {
    backgroundColor: theme.colors.roseQuartz,
  },
}));

const Alert: FC<AlertProps> = (props) => {
  const { children, icon, ...others } = props;
  return (
    <StyledAlert icon={icon || <ReportIcon />} {...others}>
      {children}
    </StyledAlert>
  );
};

export default Alert;
